;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/login\"},{\"path\":\"/\"},{\"path\":\"/collections\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import { CrashReporter } from '@viziertronic/crash-reporter'

import { InstrumentationBrowserRuntime } from '#runtime/instrumentation-browser.runtime.ts'

void InstrumentationBrowserRuntime.runPromise(
  CrashReporter.use((cr) => cr.init()),
)
